// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from "vue-router";
import Axios from 'axios'
import ElementUI from 'element-ui'
import less from 'less'
import { VueMasonryPlugin } from 'vue-masonry';
import store from './store'
import wordcloud from "echarts-wordcloud";
import VueI18n from 'vue-i18n';
import cnJSON from "../static/cn"
import enJSON from "../static/en"

var echarts = require('echarts')
    // import '@/utils/china'
import 'element-ui/lib/theme-chalk/index.css'
// import '@/utils/snorql'
Vue.config.productionTip = false
Vue.prototype.$axios = Axios
Vue.prototype.$echarts = echarts
Vue.prototype.$baseurl = window.location.href.indexOf("10.") >= 0 || window.location.href.indexOf("dev") >= 0 || window.location.href.indexOf("localhost") >= 0 ? 'http://10.10.10.225:8117' : 'https://geoclassmap.acemap.cn'
    // Vue.prototype.$baseurl ='https://geoclassmap.acemap.cn'
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(less)
Vue.use(echarts)
Vue.use(VueMasonryPlugin)
Vue.use(wordcloud);
Vue.use(VueI18n);
// Vue.use(leaflet)
Vue.config.productionTip = false

const i18n = new VueI18n({
    fallbackLocale: 'en', // 预设的语言环境
    defaultLocale: 'en',
    locale: ['en', 'cn'], // 语言环境
    globalInjection: true, // 全局注册$t方法
    messages: {
        en: enJSON,
        cn: cnJSON,
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    i18n,
    components: { App },
    template: '<App/>',
    store: store
})

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
    return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/main.js